import styled from "@emotion/styled";

export const ButtonStyled = styled.div`
  &.btn{
     button{
       font-family: 'Roboto';
       cursor: ${props => props.customStyles.disabled ? 'not-allowed':'pointer'} ;
       opacity: ${props => props.customStyles.disabled ? '0.1':'1'};
       border-radius: 2px;
       height: ${props => props.customStyles.height};
       width: ${props => props.customStyles.width};
       display: flex;
       justify-content: center;
       align-items: center;
       user-select: none;
       outline: none;
       border: none;
       font-size: 18px;
       font-weight: 500;
       //cursor: not-allowed;
     }
  }
  &.btn-default{
    button{
      background: ${props => props.theme.palette.default.main};
      color: ${props => props.theme.palette.default.contrastText};
    }
  }
  &.btn-primary{
    button{
      border: 2px solid ${props => props.theme.palette.divider};
      background: ${props => props.theme.palette.primary.main};
      color: ${props => props.theme.palette.primary.contrastText};
    }
  }
  &.btn-link{
    button{
      border: none;
      background: transparent;
      color: ${props => props.theme.palette.text.primary};
      &:hover{
        background-color: ${props => props.theme.palette.action.hover};
        text-decoration: underline;
      }
    }
  }
  &.btn-dashed{
    button{
      border: 2px dashed ${props => props.theme.palette.divider};
      background: ${props => props.theme.palette.primary.main};
      color: ${props => props.theme.palette.primary.contrastText};
    }
  }
`;
